import { render, staticRenderFns } from "./DiscussionForum.vue?vue&type=template&id=6dbfec49&"
import script from "./DiscussionForum.vue?vue&type=script&lang=js&"
export * from "./DiscussionForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports